// src/libs/utils/time.ts

/**
 * 將時間字串轉成「幾分鐘 / 幾小時 / 幾天 / 幾週」的短標籤
 *
 * 規則：
 * - 0~59 分 → X分鐘（最少 1 分鐘）
 * - 60 分起 → X小時（取整數小時）
 * - 24 小時起 → X天（取整數天）
 * - 7 天起 → X週（取整數週：7 天 → 1週，14 天 → 2週，...）
 *
 * 若解析失敗或是未來時間，就直接回傳原本字串。
 */
export function formatMessageTimeLabel(dateTimeStr?: string): string {
  if (!dateTimeStr) return '';

  // 你的 normalizeDateTime 目前大概會長：'2025-11-24 03:48'
  // 簡單轉成瀏覽器可吃的格式：'2025-11-24T03:48'
  const normalized = dateTimeStr.trim().replace(' ', 'T');
  const target = new Date(normalized);

  if (Number.isNaN(target.getTime())) {
    // 解析失敗就用原字串
    return dateTimeStr;
  }

  const now = new Date();
  const diffMs = now.getTime() - target.getTime();

  // 未來時間就不要亂算，直接顯示原字串
  if (diffMs < 0) {
    return dateTimeStr;
  }

  const diffMinutes = Math.floor(diffMs / (60 * 1000));
  const diffHours = Math.floor(diffMinutes / 60);
  const diffDays = Math.floor(diffHours / 24);

  // 0 ~ 59 分鐘
  if (diffMinutes < 60) {
    const mins = Math.max(diffMinutes, 1); // 最少顯示「1分鐘」
    return `${mins}分鐘`;
  }

  // 1 ~ 23 小時
  if (diffHours < 24) {
    return `${diffHours}小時`;
  }

  // 1 ~ 6 天
  if (diffDays < 7) {
    return `${diffDays}天`;
  }

  // 7 天以上 → 週
  const diffWeeks = Math.floor(diffDays / 7); // 7天→1週，14天→2週 ...
  return `${diffWeeks}週`;
}
